import Processing from '@eversports/klimt-primitives/legacy/Processing'
import * as React from 'react'

import MobileButtonContainer from '../components/MobileButtonContainer'
import ParticipationButton from '../components/ParticipationButton'

interface Props {
  isUserJoiningMatch: boolean
  handleClick: () => void
  isMobile: boolean
  isDisabled: boolean
}

const JoinMatchButton = ({
  children,
  isUserJoiningMatch,
  handleClick,
  isMobile,
  isDisabled,
}: React.PropsWithChildren<Props>) => {
  return isMobile ? (
    <MobileButtonContainer>
      <Processing isLoading={isUserJoiningMatch}>
        <ParticipationButton onClick={handleClick} isDisabled={isDisabled}>
          {children}
        </ParticipationButton>
      </Processing>
    </MobileButtonContainer>
  ) : (
    <Processing isLoading={isUserJoiningMatch}>
      <ParticipationButton onClick={handleClick} isDisabled={isDisabled}>
        {children}
      </ParticipationButton>
    </Processing>
  )
}

export default JoinMatchButton
